package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SchoolWeeklyHolidayConfigCreateRequest(
    @SerialName("day_of_week") val dayOfWeek: Int = 0
)

@Serializable
data class CalendarEventCreateRequest(
    @SerialName("event_date") val eventDate: String,
    @SerialName("is_all_day") val isAllDay: Boolean = false,
    @SerialName("from_time") val fromTime: String? = null,
    @SerialName("to_time") val toTime: String? = null,
    @SerialName("event_title") val eventTitle: String,
    @SerialName("event_type") val eventType: String,
    @SerialName("applicable_to") val applicableTo: String = "ALL",
    val status: String = "DRAFT",
    @SerialName("is_weekly_holiday") val isWeeklyHoliday: Boolean = false
)

@Serializable
data class CalendarEventBulkCreateRequest(
    val events: List<CalendarEventCreateRequest>,
    val status: String = "DRAFT"
)

@Serializable
data class CalendarEventUpdateRequest(
    @SerialName("academic_year_id") val academicYearId: String? = null,
    @SerialName("event_date") val eventDate: String? = null,
    @SerialName("is_all_day") val isAllDay: Boolean? = null,
    @SerialName("from_time") val fromTime: String? = null,
    @SerialName("to_time") val toTime: String? = null,
    @SerialName("event_title") val eventTitle: String? = null,
    @SerialName("event_type") val eventType: String? = null,
    @SerialName("applicable_to") val applicableTo: String? = null,
    val status: String? = null,
    @SerialName("is_weekly_holiday") val isWeeklyHoliday: Boolean? = null
)
